import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { Country, Locality, State } from '../../models/City';

const LOCALITIES_URL = 'https://hubspot-public-content.s3.sa-east-1.amazonaws.com/localities-updated.json';

export const fetchData = createAsyncThunk(
  'fetchData',
  async () => {
    const { data } = await axios.get(LOCALITIES_URL);
    return data;
  }
);

export interface LocalitiesStore {
  countries: Country[];
  cities: Locality[];
  states: State[];
  loaded: boolean;
}

const initialState:LocalitiesStore = {
  countries: [],
  cities: [],
  states: [],
  loaded: false
};

const objectEntriesToArray = <T>(object:T[]):T[] => {
  return Object.entries(object).map((item) => item[1]);
};

const localitiesSlice = createSlice({
  name: 'localities',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.countries = objectEntriesToArray<Country>(action.payload.countries);
      state.states = objectEntriesToArray<State>(action.payload.states);
      state.cities = action.payload.cities;
      state.loaded = true;
    });
  }
});

export default localitiesSlice.reducer;
